module.exports = __webpack_public_path__ + "img/facebook-profile-instruction-5.b07afe94.png";